import {Check} from "@sparkware/app-utils";

export class HttpError {
    public readonly statusCode: number;
    public readonly message: string;

    constructor({status, statusText}: Response) {
        this.statusCode = status;
        this.message = status + ' - ' + statusText;
    }
}


export async function parseFetchResponse(response: Response): Promise<any> {

    const contentTypeHeader = response.headers.get('content-type') || '';

    if(Check.isEmpty(contentTypeHeader) || contentTypeHeader.indexOf('application/json') >= 0) {
        return await response.json();
    } else if(contentTypeHeader.indexOf('text/plain') >= 0) {
        return await response.text();
    }

    let charset = 'utf-8';
    if(contentTypeHeader.indexOf('charset=') > -1) {
        [,charset] = /charset=([^ ]+)/.exec(contentTypeHeader);
    }

    const blob = await response.blob();
    return await decodeBlob(blob, charset);
}


function decodeBlob(source: Blob, encoding: string = 'utf-16'): Promise<string> {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve(reader.result as string);
        };
        reader.readAsText(source, encoding);
    })
}